export const en = {
    "devices": "Devices",
    "fill-fields-to-test": "To test a skill, you must fill in all required fields",
    "headline": "Testing",
    "log": "Requests log",
    "no-published": "You have not published any version of the dialog yet",
    "smart-home": "Smart home",
    "check-that-your-skill-is-ready": "Check that your skill is ready before sending it for moderation"
} as const;
export const ru = {
    "devices": "К устройствам",
    "fill-fields-to-test": "Для тестирования навыка необходимо заполнить все обязательные поля",
    "headline": "Тестирование",
    "log": "Лог запросов",
    "no-published": "Вы еще не опубликовали ни одной версии диалога",
    "smart-home": "Умный дом",
    "check-that-your-skill-is-ready": "Перед отправкой навыка на модерацию проверьте его готовность"
} as const;